import { render, staticRenderFns } from "./electric-list.vue?vue&type=template&id=6b4d8a31&scoped=true&"
import script from "./electric-list.vue?vue&type=script&lang=js&"
export * from "./electric-list.vue?vue&type=script&lang=js&"
import style0 from "./electric-list.vue?vue&type=style&index=0&id=6b4d8a31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4d8a31",
  null
  
)

export default component.exports